"use client";

import { sendGTMEvent } from "@next/third-parties/google";

import type { ProductDataLayerType } from "./types";
import { GTagEvents } from "./types";

type AddToCartProps = {
  item: ProductDataLayerType;
  value: number;
  currency: string;
  coupon?: string;
};

export const addToCartEvent = ({
  item,
  value,
  currency,
  coupon,
}: AddToCartProps) => {
  // Zgodnie z dokumentacją, coupon ma być w items
  // https://developers.google.com/analytics/devguides/collection/ga4/reference/events?sjid=3919204348520299324-EU&hl=pl&client_type=gtag#add_to_cart
  if (coupon) {
    item.coupon = coupon;
  }

  console.log("addToCartEvent", item, value, currency);

  sendGTMEvent({
    event: GTagEvents.ADD_TO_CART,
    currency,
    items: [item],
    value,
  });
};
